import { createContext } from 'react';

export const UpgradeFlowContext = createContext({
  canOpen: false,
  open: () => {},
});
